export const getCookieValue = (name: string) => {
	const rawCookieData =
		document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
	return decodeURIComponent(rawCookieData);
};
